import React, { useState } from 'react';
import { Modal, Form, Input, DatePicker, Button } from 'antd';

const RecordPayment = ({ visible, onClose, onSave }) => {
  const [form] = Form.useForm();

  const handleOk = () => {
    form.validateFields().then(values => {
      onSave({
        date: values.date.format('YYYY-MM-DD'),
        amount: values.amount,
        reference: values.reference,
      });
      form.resetFields();
    });
  };

  return (
    <Modal
      title="Record Payment"
      open={visible}
      onCancel={onClose}
      onOk={handleOk}
      okText="Save"
      cancelText="Cancel"
    >
      <Form form={form} layout="vertical">
        <Form.Item label="Date" name="date" rules={[{ required: true, message: 'Please select date' }]}> 
          <DatePicker style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item label="Amount" name="amount" rules={[{ required: true, message: 'Please enter amount' }]}> 
          <Input type="number" />
        </Form.Item>
        <Form.Item label="Notes" name="reference"> 
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default RecordPayment;
